module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.7vw"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 2),
      expression: "orderStatus===1||orderStatus===2"
    }]
  }, _vm._l((_vm.orderList.waitApprovedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(1, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_red"
    }, [_vm._v("\n            未审批\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 3),
      expression: "orderStatus===1||orderStatus===3"
    }]
  }, _vm._l((_vm.orderList.executedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(2, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_orange"
    }, [_vm._v("\n            执行中\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 4),
      expression: "orderStatus===1||orderStatus===4"
    }]
  }, _vm._l((_vm.orderList.finishedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(2, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_greeen"
    }, [_vm._v("\n            已完成\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(2, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a9b998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/OrderInfoList.vue
// module id = 1576
// module chunks = 8